import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=40b26d0a"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b26d0a')) {
      api.createRecord('40b26d0a', component.options)
    } else {
      api.reload('40b26d0a', component.options)
    }
    module.hot.accept("./Badge.vue?vue&type=template&id=40b26d0a", function () {
      api.rerender('40b26d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/components/Badge.vue"
export default component.exports